var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppPublication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.55479 13.6156C1.55479 14.0446 1.20732 14.3939 0.777396 14.3939C0.348952 14.3939 0 14.0446 0 13.6156C0 6.10104 6.09403 0 13.6 0C21.106 0 27.2 6.10104 27.2 13.6156C27.2 14.0446 26.8525 14.3939 26.4226 14.3939C25.9942 14.3939 25.6452 14.0446 25.6452 13.6156C25.6452 6.95876 20.2477 1.55658 13.6 1.55658C6.95077 1.55658 1.55479 6.96027 1.55479 13.6156ZM13.6 5.93161C18.581 5.93161 22.6238 9.97947 22.6238 14.9658C22.6238 19.9525 18.5806 24 13.6 24C8.61901 24 4.57618 19.9521 4.57618 14.9658C4.57618 9.97909 8.61939 5.93161 13.6 5.93161ZM13.6 7.48819C9.47726 7.48819 6.12946 10.8387 6.12946 14.9658C6.12946 19.0929 9.47609 22.4449 13.6 22.4449C17.7227 22.4449 21.069 19.0945 21.069 14.9658C21.069 10.8383 17.7224 7.48819 13.6 7.48819ZM19.1226 11.5681C19.5128 11.3883 19.9751 11.5593 20.1533 11.9499C20.3329 12.3405 20.1606 12.8033 19.7719 12.9817L13.9237 15.6718C13.5335 15.8517 13.0712 15.6807 12.893 15.2901C12.7134 14.8994 12.8842 14.4366 13.2743 14.2582L19.1211 11.5681H19.1226Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppPublication);
export default __webpack_public_path__ + "static/media/appPublication.a44a17030c9c87c336a227a39c461894.svg";
export { ForwardRef as ReactComponent };